module.exports = __webpack_public_path__ + "media/click.eae170b4.mp3";